import React, { useEffect, useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { classesAtom } from '_state';
import { useClassActions } from '_actions';
import { ROLES } from '_helpers/roles';
import { AttendanceTable } from './AttendanceTable';

export { AttendancePage };

function AttendancePage() {
    const classes = useRecoilValue(classesAtom);
    const userData = useMemo(() => JSON.parse(localStorage.getItem('userData') || 'null'), []);
    const isStudent = userData?.role === ROLES.STUDENT;

    const classActions = useClassActions();
    useEffect(() => {
        if (isStudent && classes.length === 0) classActions.getClassList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isStudent]);

    return (
        <div className="p-4">
            <AttendanceTable />
        </div>
    );
}
